module.exports = __webpack_public_path__ + "static/media/Yevgen.17921887.jpg";